import { useAtomValue } from "jotai";
import { questionnaireIsEditingAtom } from "../state/questionnaireIsEditingAtom";

/**
 * Get whether questionnaire is in edit mode (modifying previously submitted answers).
 *
 * @example const isEditing = useIsEditing();
 */
export function useIsEditing(): boolean | undefined {
  return useAtomValue(questionnaireIsEditingAtom);
}
